// CardPage.jsx
import React, { useRef, useEffect } from "react";
import VehicleRegistrationCard from "./VehicleRegistrationCard";
import PDFWrapper from "./PDFWrapper";

export default function CardPage({ rcData, apiTriggerDownload }) {
  const pdfRef = useRef();

  // Call this from API function when needed:
  useEffect(() => {
    // Register callback once after mount
    apiTriggerDownload(() => {
      pdfRef.current?.generatePDF();
    });
  }, []);

  return (
    <>
      <PDFWrapper ref={pdfRef} fileName={`${rcData?.rcNumber}.pdf`}>
        <VehicleRegistrationCard rcData={rcData} />
      </PDFWrapper>
    </>
  );
}
